import * as React from "react";

function SvgDoubleCheck(props) {
  return <svg width={12} height={12} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8 15L13 20" stroke="#999" strokeWidth={2.5} strokeLinecap="round" /><path d="M2 15L7 20" stroke="#999" strokeWidth={2.5} strokeLinecap="round" /><path d="M13 20L22 6" stroke="#999" strokeWidth={2.5} strokeLinecap="round" /><path d="M12 12.7842L16.24 6.00019" stroke="#999" strokeWidth={2.5} strokeLinecap="round" /></svg>;
}

export default SvgDoubleCheck;